// DepartmentTab.tsx
import React from 'react';

import { Card } from 'primereact/card';
import { ScrollPanel } from 'primereact/scrollpanel';

import { TreeNode } from '../../types/interfaces';
import { CustomDropdown } from '../custom-controls/CustomDropdown';
import { TagsComponent } from '../TagsComponent';

interface DepartmentTabProps {
  errors: any;
  departments: any[];
  selectedDepartments: any[];
  handleSelectionChange: (e: any, type: string) => void;
  handleDeleteSelectedDepartments: (id: string | number) => void;
}

const DepartmentTab: React.FC<DepartmentTabProps> = ({
  errors,
  departments,
  selectedDepartments,
  handleSelectionChange,
  handleDeleteSelectedDepartments
}) => {

  const updateSelection = (selection: TreeNode[]) => {
    handleSelectionChange(selection, 'department');
  };

  const onTreeSelectionChange = (selection: TreeNode | TreeNode[]) => {
    updateSelection(Array.isArray(selection) ? selection : [selection]);
  };

  const handleSetSelectedAsset = (
    value: React.SetStateAction<TreeNode | TreeNode[] | null>
  ) => {
    if (typeof value === 'function') {
      const result = value(selectedDepartments);
      const array = result === null ? [] : Array.isArray(result) ? result : [result];
      handleSelectionChange(array, 'department');
      return array;
    } else {
      const array = value === null ? [] : Array.isArray(value) ? value : [value];
      updateSelection(array);
    }
  };

  return (
    <div className="flex flex-column md:flex-row gap-3">
      <div className="flex flex-column w-full">
        <div className="flex flex-column">
          <div className="flex justify-content-between align-items-center gap-3">
            <CustomDropdown<TreeNode>
              useTree={true}
              multiplySelectMode={true}
              treeValue={departments.filter(i => (i.key !== '0' && i.key !== 0))}
              selectedAsset={selectedDepartments}
              setSelectedAsset={handleSetSelectedAsset}
              onTreeSelectionChange={onTreeSelectionChange}
              fixedLabel={
                selectedDepartments?.length > 0
                  ? `Выбрано участков: ${selectedDepartments?.length}`
                  : 'Выберите участки'
              }
              style={{ width: '440px' }}
              assetOptions={[]}
              showClearOnHover
            />
          </div>
          <p
            className={`employee-card-errors card-errors ${
              errors.department ? 'text-red-500' : 'text-transparent'
            } `}
          >
            {errors.department ? errors.department.message : ' '}
          </p>
        </div>
        <Card style={{ width: '100%', color: '#6c757d' }}>
          <p className="m-0">Выбранные участки:</p>
          <ScrollPanel
            style={{ width: '100%', height: '150px' }}
            className="employee-card-scroll-pannel"
          >
            {selectedDepartments?.length === 0 && <p>Участки не выбраны</p>}
            <TagsComponent
              initialTagsItems={selectedDepartments}
              onDelete={handleDeleteSelectedDepartments}
            />
          </ScrollPanel>
        </Card>
      </div>
    </div>
  );
};

export default DepartmentTab;
